import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Sidebar.css";
import { FaCog, FaTasks } from "react-icons/fa";
import { File, GitMerge, Network } from "lucide-react";
import {
  DashboardIcon,
  DataSourceIcon,
  MappingIcon,
} from "../../assets/icon/svgIcons";
import MyLogo from "../../assets/chatbot.png";
import TaskManagement from "../pages/Todo/TaskManagement";

const Sidebar = ({ isOpen }) => {
  const location = useLocation(); // Get current path to highlight active tab

  const {
    Dashboard,
    DataSource,
    Upload,
    STTMapping,
    Administration,
    ToDo,
    AIAsst,
  } = JSON.parse(sessionStorage.getItem("rolesAndPermission") || "{}");

  return (
    <>
      {!isOpen && (
        <div className="sidebar closed">
          <ul className={`sidebar-menu ${isOpen ? "" : "margin-closed"}`}>
            {Dashboard?.canView && (
              <li
                className={location.pathname === "/dashboard" ? "active" : ""}
              >
                <Link
                  className={`flex ${
                    !isOpen ? "flex-col" : "flex-row"
                  } sidebar-dashboard-joyride-class`}
                  to="/dashboard"
                  title="Dashboard"
                >
                  <DashboardIcon />
                  <div className="sidebar-label">Dashboard</div>
                </Link>
              </li>
            )}
            {DataSource?.canView && (
              <li
                className={
                  location.pathname.includes("/data-sources") ? "active" : ""
                }
              >
                <Link
                  className={`flex ${
                    !isOpen ? "flex-col" : "flex-row"
                  } sidebar-datasource-joyride-class`}
                  to="/data-sources"
                  title="Data Sources"
                >
                  <DataSourceIcon />
                  <div className="sidebar-label">Data Sources</div>
                </Link>
              </li>
            )}
            {Upload?.canView && (
              <li
                className={
                  location.pathname.includes("/upload") ? "active" : ""
                }
              >
                <Link
                  className={` flex ${
                    !isOpen ? "flex-col" : "flex-row"
                  } sidebar-upload-joyride-class`}
                  to="/upload"
                  title="Upload"
                >
                  <File className="menu-icon" />
                  <div className="sidebar-label">Upload</div>
                </Link>
              </li>
            )}
            {STTMapping?.canView && (
              <li
                className={
                  location.pathname === "/view-data" ||
                  location.pathname.includes("/history-data")
                    ? "active"
                    : ""
                }
              >
                <Link
                  className={` flex ${
                    !isOpen ? "flex-col" : "flex-row"
                  } sidebar-stt-joyride-class`}
                  to="/view-data"
                  title="View Data"
                >
                  <MappingIcon />
                  <div className="sidebar-label">Mapping</div>
                </Link>
              </li>
            )}

            {/* <li
              className={
                location.pathname.includes("/data-lineage") ? "active" : ""
              }
            >
              <Link
                className={`flex ${
                  !isOpen ? "flex-col" : "flex-row"
                } sidebar-ai-joyride-class`}
                to="/data-lineage"
                title="Reverse Engineering"
              >
                <Network />
                <div className="sidebar-label">Reverse Engineering</div>
              </Link>
            </li> */}
            <li className={location.pathname.includes("/erd") ? "active" : ""}>
              <Link
                className={`flex ${
                  !isOpen ? "flex-col" : "flex-row"
                } sidebar-ai-joyride-class`}
                to="/erd"
                title="Reverse Engineering"
              >
                <Network />
                <div className="sidebar-label">Reverse Engineering</div>
              </Link>
            </li>
            {AIAsst?.canView && (
              <li
                className={
                  location.pathname.includes("/falcon-ai") ? "active" : ""
                }
              >
                <Link
                  className={`flex ${
                    !isOpen ? "flex-col" : "flex-row"
                  } sidebar-ai-joyride-class`}
                  to="/falcon-ai"
                  title="Bluegecko AI"
                >
                  <img
                    src={MyLogo}
                    alt="My Logo"
                    className="menu-icon w-6 h-6" // adjust size as needed
                  />
                  <div className="sidebar-label">BlueGecko AI</div>
                </Link>
              </li>
            )}

            {ToDo?.canView && (
              <li
                className={location.pathname.includes("/task") ? "active" : ""}
              >
                <Link
                  className={`flex ${
                    !isOpen ? "flex-col" : "flex-row"
                  } sidebar-ai-joyride-class`}
                  to="/task"
                  title="Task Management"
                >
                  <FaTasks className="text-blue-600 w-5 h-5" />{" "}
                  {/* Task management */}
                  <div className="sidebar-label">Task Management</div>
                </Link>
              </li>
            )}

            {Administration?.canView && (
              <li
                className={
                  location.pathname.includes("/admin-interface") ? "active" : ""
                }
              >
                <Link
                  className={` flex ${
                    !isOpen ? "flex-col" : "flex-row"
                  } sidebar-settings-joyride-class`}
                  to="/admin-interface"
                  title="Settings"
                >
                  <FaCog className="menu-icon" />
                  <div className="sidebar-label">Admin Settings</div>
                </Link>
              </li>
            )}
          </ul>
        </div>
      )}
    </>
  );
};

export default Sidebar;
